// extracted by mini-css-extract-plugin
export default {"reportsTabContainer":"mzAYPJCh8mZfbt5k0EpJ"};